import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { base16AteliersulphurpoolLight } from 'react-syntax-highlighter/dist/cjs/styles/prism';

const WithdrawalReturnNotification = memo(() => {
    const { t, i18n } = useTranslation();

    return (
        <div className='flex-col' style={{ gap: 30 }}>
            <div>
                <p className='fs-header inter-extrabold'>{t('docs.withdrawalReturnNotification')}</p>
                <p className='fs-content p-t-10 lh-13'>
                    {t('docs.withdrawalReturnNotificationDesc')}</p>
            </div>

            <div>
                <p className='fs-title-docs inter-extrabold' id="wrn_httpRequest">{t('docs.httpRequest')}</p>
                <div className='table-box'>
                    <div className='flex-str'>
                        <div className='table-title'>
                            <p>{t('docs.body')}</p>
                        </div>
                        <div className='table-content code-lh'>
                            <div className='codesnip'>
                                <div className='p-tb-10 p-l-15 fs-12' style={{ backgroundColor: '#f5f7ff', color: '#000000', fontWeight: 'bold', userSelect: 'none' }}>
                                    JSON
                                </div>
                                <SyntaxHighlighter
                                    language='json'
                                    style={base16AteliersulphurpoolLight}
                                    customStyle={{ margin: 0, paddingTop: 5, fontSize: 14 }}
                                    wrapLines={true}
                                    wrapLongLines={true}
                                >
                                    {`{\n\t"nonce": "integer",\n\t"sign": "string",\n\t"txid": "string",\n\t"amount": "float",\n\t"network": "string",\n\t"token": "string",\n\t"order_id": "string"\n}`}
                                </SyntaxHighlighter>
                            </div>
                        </div>
                    </div>
                    <div className='flex-str'>
                        <div className='table-title'>
                            <p>{t('docs.desc')}</p>
                        </div>
                        <div className='table-content'>
                            <div className='flex-str'>
                                <p className='table-subtitle'>nonce</p>
                                <p className='table-subcontent'>{t('docs.randomNumber')}</p>
                            </div>
                            <div className='flex-str'>
                                <p className='table-subtitle'>sign</p>
                                <p className='table-subcontent'>{t('docs.callbackSignature')}</p>
                            </div>
                            <div className='flex-str'>
                                <p className='table-subtitle'>txid</p>
                                <p className='table-subcontent'>{t('docs.transactionHash')}</p>
                            </div>
                            <div className='flex-str'>
                                <p className='table-subtitle'>amount</p>
                                <p className='table-subcontent'>{t('docs.transactionAmount')}</p>
                            </div>
                            <div className='flex-str'>
                                <p className='table-subtitle'>network</p>
                                <p className='table-subcontent'>{t('docs.blockchainNetwork')}</p>
                            </div>
                            <div className='flex-str'>
                                <p className='table-subtitle'>token</p>
                                <p className='table-subcontent'>{t('docs.blackchainToken')}</p>
                            </div>
                            <div className='flex-str'>
                                <p className='table-subtitle'>order_id</p>
                                <p className='table-subcontent'>{t('docs.orderIdCompleteWithdrawal')}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div>
                <p className='fs-title-docs inter-extrabold' id="wrn_httpResponse">{t('docs.httpResponse')}</p>
                <div className='table-box'>
                    <div className='flex-str'>
                        <div className='table-title'>
                            <p>{t('docs.body')}</p>
                        </div>
                        <div className='table-content code-lh'>

                            <div className='codesnip'>
                                <div className='p-tb-10 p-l-15 fs-12' style={{ backgroundColor: '#f5f7ff', color: '#000000', fontWeight: 'bold', userSelect: 'none' }}>
                                    JSON
                                </div>
                                <SyntaxHighlighter
                                    language='json'
                                    style={base16AteliersulphurpoolLight}
                                    customStyle={{ margin: 0, paddingTop: 5, fontSize: 14 }}
                                    wrapLines={true}
                                    wrapLongLines={true}
                                >
                                    {`{\n\t"success": true\n}`}
                                </SyntaxHighlighter>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
});

// const useStyles = makeStyles((theme) => ({

// }));

export default WithdrawalReturnNotification;